import { Component } from 'react';

import './HistoricalDatasets.css';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';

import request from '@acri-tools/react-tools/utils/request';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import CSVTable from '../../../../components/CSVTable/CSVTable';
import { get_data_file_url } from '../../../../utils/data';

interface Props {
    csv: string
}
interface State {
    loading: boolean

    data?: any
}

export default class HistoricalDatasets extends Component<Props, State>{
    constructor(props: Props) {
        super(props);
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
        this.fetch_data();
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.csv !== prevProps.csv) this.fetch_data();
    }


    fetch_data = async () => {
        this.setState({ loading: true });
        try {
            let res = await request(get_data_file_url(this.props.csv), {
                method: 'get'
            })

            this.setState({ data: res.data });
        }
        catch (e: any) {
            axiosErrorHandler(e, { functionName: `fetch_data` });
            toast_request_error(e);
        }
        finally {
            this.setState({ loading: false })
        }
    }


    render() {
        return (
            <div className="historical-datasets">
                {
                    this.state.loading ?
                        <div className="centered">
                            <Spinner />
                        </div>
                        :
                        this.state.data &&
                        <CSVTable
                            update_filter
                            export export_name="historical_dataset_list"
                            data={this.state.data}
                            parse_options={{
                                delimiter: ';'
                            }}
                            hide_rows={[
                                8, 9, 10, 11
                            ]}
                            // filter_preserve={[ 0 ]}
                            filters={[
                                { index: 0, label: <><i className="fas fa-satellite" /> Missions</> },
                                { index: 1, label: <><i className="fas fa-drafting-compass" /> Instruments</> },
                                { index: 2, label: <><i className="fas fa-cogs" /> Product Types</> },
                                { index: 3, label: <><i className="fas fa-layer-group" /> Dataset</> },
                                { index: 13, label: <><i className="fas fa-external-link-alt" /> Format</> },
                                { index: 14, label: <><i className="fas fa-list" /> Master Dataset</> },
                            ]}
                            // header_title={{
                            //     7: "size"
                            // }}
                            sort_columns={{
                                0: { filter: 'alphabetical' },
                                1: { filter: 'alphabetical' },
                                2: { filter: 'alphabetical' },
                                3: { filter: 'alphabetical' },
                                4: { filter: 'alphabetical' },
                                5: { filter: 'numerical' },
                                6: { filter: 'numerical' },
                                7: { filter: 'numerical' },
                                12: { filter: 'alphabetical' },
                                13: { filter: 'alphabetical' },
                                14: { filter: 'alphabetical' }
                            }}
                        // parse_columns={{
                        //     7: (value)=>{ return format_bytes(value * Math.pow(1000, 1), { base: 1000 }) }
                        // }}
                        />
                }
            </div>
        );
    }

};
